import { useEffect, useState } from 'react';
import { CookieBanner } from '../components/common/CookieBanner';
import { trackWhatsAppLead } from '../lib/trackLead';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const IMG = {
  hero: '/soldeu/hero.jpg',
  intro: '/soldeu/intro.jpg',
  instructionPortrait: '/soldeu/instructionPortrait.jpg',
  range: '/soldeu/range.jpg',
  instructionWide: '/soldeu/instructionWide.jpg',
  lakeFlowers: '/soldeu/lakeFlowers.jpg',
  aerial: '/soldeu/aerial.jpg',
  joan: '/soldeu/joan.jpg'
};

export default function SoldeuLandingPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/soldeu-landing`).then(r => r.json()).then(setData).catch(() => {});
  }, []);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'Forat Zero — El teu primer forat aquí dalt';
    const fonts = document.createElement('link');
    fonts.rel = 'stylesheet';
    fonts.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Outfit:wght@300;400;500;600;700&display=swap';
    const fa = document.createElement('link');
    fa.rel = 'stylesheet';
    fa.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css';
    const style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = '/soldeu/landing.css';
    document.head.appendChild(fonts);
    document.head.appendChild(fa);
    document.head.appendChild(style);
    return () => {
      document.title = prevTitle;
      document.head.removeChild(fonts);
      document.head.removeChild(fa);
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    if (!data || !data.t) return;
    const WHATSAPP = data.whatsapp;
    const YT = data.yt;
    const T = data.t;
    const LANGS = data.langs || [];
    const SUPPORTED = LANGS.map(l => l.code);

    let lang = (function () {
      const saved = localStorage.getItem('fz_lang');
      if (saved && SUPPORTED.indexOf(saved) >= 0) return saved;
      const n = (navigator.language || 'ca').slice(0, 2).toLowerCase();
      return SUPPORTED.indexOf(n) >= 0 ? n : 'ca';
    })();

    let obs = null;
    function waUrl() { return 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent(T[lang].whatsapp); }
    function openWA() {
      trackWhatsAppLead('iniciacio-a-soldeu', { language: lang });
      window.open(waUrl(), '_blank', 'noopener');
    }

    function bind() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-wa]'), function (b) { b.onclick = openWA; });
      const vw = document.getElementById('videoWrap');
      if (vw) {
        vw.onclick = function () {
          vw.innerHTML = '<iframe style="position:absolute;inset:0;width:100%;height:100%;border:0" src="https://www.youtube.com/embed/' + YT + '?autoplay=1&rel=0" allow="autoplay;encrypted-media;fullscreen" allowfullscreen></iframe>';
        };
      }
      const st = document.querySelector('[data-scrolltop]');
      if (st) { st.onclick = openWA; }
      if (obs) obs.disconnect();
      obs = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('show'); obs.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '-40px' });
      Array.prototype.forEach.call(document.querySelectorAll('.reveal'), function (el) { obs.observe(el); });
    }

    function render() {
      const t = T[lang];
      document.documentElement.lang = lang;
      document.getElementById('langCode').textContent = lang.toUpperCase();

      document.getElementById('navmain').innerHTML =
        '<a href="#method">' + t.nav.method + '</a>' +
        '<a href="#experience">' + t.nav.experience + '</a>' +
        '<a href="#session">' + t.nav.session + '</a>' +
        '<a href="#about">' + t.nav.about + '</a>';
      document.getElementById('headerBook').textContent = t.nav.book;
      document.getElementById('waFloatTxt').textContent = t.nav.book;

      document.getElementById('langMenu').innerHTML = LANGS.map(function (l) {
        return '<button data-lang="' + l.code + '">' + l.label + (l.code === lang ? ' <i class="fa-solid fa-check" style="color:var(--primary)"></i>' : '') + '</button>';
      }).join('');

      const heroLines = t.hero.lines.map(function (l) { return '<span style="display:block">' + l + '</span>'; }).join('');
      const mq = t.marquee.concat(t.marquee, t.marquee).map(function (m) { return '<span class="txt">' + m + '</span><span class="star">&#10022;</span>'; }).join('');
      const stats = t.hero.stats.map(function (s) { return '<div class="stat"><div class="num">' + s.v + '</div><div class="lbl">' + s.l + '</div></div>'; }).join('');
      const steps = t.method.steps.map(function (s) { return '<div class="step reveal"><span class="n">' + s.n + '</span><div><h3>' + s.title + '</h3><p>' + s.text + '</p></div></div>'; }).join('');
      const lparas = t.letter.paras.map(function (p, i) { return '<p class="reveal' + (i === 0 ? ' first' : '') + '">' + p + '</p>'; }).join('');
      const inc = t.vip.includes.map(function (x) { return '<li><span class="ck"><i class="fa-solid fa-check"></i></span><span>' + x + '</span></li>'; }).join('');
      const metaIcons = ['fa-clock', 'fa-euro-sign', 'fa-calendar-days', 'fa-users'];
      const meta = t.vip.meta.map(function (m, i) { return '<div class="cell"><i class="fa-solid ' + metaIcons[i] + '"></i><div class="k">' + m.label + '</div><div class="v">' + m.value + '</div></div>'; }).join('');
      const aparas = t.about.paras.map(function (p) { return '<p class="lead reveal" style="margin-top:20px">' + p + '</p>'; }).join('');
      const credits = t.about.credits.map(function (c) { return '<div><div class="cname">' + c.name + '</div><div class="corg">' + c.org + '</div></div>'; }).join('');

      document.getElementById('app').innerHTML =
        '<section class="hero" id="top">' +
          '<div class="hero-bg"><img src="' + IMG.hero + '" alt="Soldeu Golf"></div>' +
          '<div class="hero-scrim"></div>' +
          '<div class="wrap hero-content">' +
            '<div class="hero-badge"><span></span>' + t.hero.badge + '</div>' +
            '<h1>' + heroLines + '</h1>' +
            '<div class="hero-sub-row">' +
              '<p class="hero-sub">' + t.hero.sub + '</p>' +
              '<button class="btn btn-light" data-wa><span>' + t.hero.cta + '</span><span class="ico"><i class="fa-solid fa-arrow-down"></i></span></button>' +
            '</div>' +
          '</div>' +
          '<div class="scrolltag"><i class="fa-solid fa-arrow-down"></i>' + t.hero.scroll + '</div>' +
        '</section>' +
        '<div class="marquee"><div class="marquee-row">' + mq + '</div></div>' +
        '<section class="pad"><div class="wrap">' +
          '<div class="intro-grid">' +
            '<div class="reveal"><div class="photo ar45"><img src="' + IMG.intro + '" style="object-position:bottom" alt="Joan Monzó & Vicky Fernández"></div></div>' +
            '<div>' +
              '<div class="kicker reveal">' + t.intro.kicker + '</div>' +
              '<h2 class="title-lg serif reveal" style="margin-top:20px">' + t.intro.title + '</h2>' +
              '<p class="lead reveal" style="margin-top:28px">' + t.intro.body + '</p>' +
              '<p class="sig reveal" style="margin-top:28px">' + t.intro.signature + '</p>' +
            '</div>' +
          '</div>' +
          '<div class="stats reveal">' + stats + '</div>' +
        '</div></section>' +
        '<section class="pad dark-sec" id="method"><div class="wrap">' +
          '<div class="method-head">' +
            '<div><div class="kicker reveal" style="color:#9cb39f">' + t.method.kicker + '</div><h2 class="reveal">' + t.method.title + '</h2></div>' +
            '<p class="method-lead reveal">' + t.method.lead + '</p>' +
          '</div>' +
          '<div class="method-grid">' +
            '<div>' + steps + '</div>' +
            '<div class="reveal"><div class="spotlight"><div class="photo ar34"><img src="' + IMG.instructionPortrait + '" alt="Classe personal"><div class="cap">Soldeu · 2.250m</div></div></div></div>' +
          '</div>' +
        '</div></section>' +
        '<section class="pad"><div class="wrap"><div class="letter">' +
          '<div class="kicker reveal">' + t.letter.kicker + '</div>' +
          '<h2 class="serif reveal">' + t.letter.title + '</h2>' +
          lparas +
          '<div class="letter-sign reveal"><div class="who"><div class="name">' + t.letter.sign + '</div><div class="role">' + t.letter.role + '</div></div><button class="btn" data-wa>' + t.nav.book + '</button></div>' +
        '</div></div></section>' +
        '<section style="padding-bottom:96px"><div class="wrap">' +
          '<div class="gal-head reveal"><span class="line"></span><span class="kicker">Grandvalira · Andorra</span></div>' +
          '<div class="gallery reveal">' +
            '<div class="frame tall"><img src="' + IMG.range + '" alt="Camp de pràctiques"></div>' +
            '<div class="stack">' +
              '<div class="frame"><img src="' + IMG.instructionWide + '" alt="Classe"></div>' +
              '<div class="frame"><img src="' + IMG.lakeFlowers + '" alt="Llac i flors"></div>' +
            '</div>' +
          '</div>' +
        '</div></section>' +
        '<section class="pad vip" id="session"><div class="wrap"><div class="vip-grid">' +
          '<div class="vip-left">' +
            '<div class="reveal"><div class="kicker">' + t.vip.kicker + '</div><h2 class="title-lg serif" style="margin-top:20px">' + t.vip.title + '</h2><p class="lead" style="margin-top:24px;max-width:440px">' + t.vip.lead + '</p></div>' +
            '<div class="reveal" style="margin-top:40px"><div class="photo" style="aspect-ratio:16/11;border-radius:28px"><img src="' + IMG.aerial + '" alt="Soldeu"></div></div>' +
          '</div>' +
          '<div class="reveal"><div class="card">' +
            '<h3 class="serif">' + t.vip.includesTitle + '</h3>' +
            '<ul class="inc">' + inc + '</ul>' +
            '<div class="meta">' + meta + '</div>' +
            '<button class="btn" data-wa>' + t.vip.cta + '</button>' +
            '<p class="foot-note">' + t.vip.footnote + '</p>' +
          '</div></div>' +
        '</div></div></section>' +
        '<section class="pad dark-sec" id="experience"><div class="wrap">' +
          '<div style="max-width:640px;margin-bottom:48px">' +
            '<div class="kicker reveal" style="color:#9cb39f">' + t.video.kicker + '</div>' +
            '<h2 class="reveal" style="color:var(--bg);font-size:clamp(34px,6vw,60px);line-height:1.02;letter-spacing:-.02em;margin:20px 0 0">' + t.video.title + '</h2>' +
            '<p class="reveal" style="color:#c3cfbf;font-size:18px;font-weight:300;margin-top:20px">' + t.video.lead + '</p>' +
          '</div>' +
          '<div class="video-wrap reveal" id="videoWrap">' +
            '<img src="https://img.youtube.com/vi/' + YT + '/maxresdefault.jpg" onerror="this.src=\'' + IMG.aerial + '\'" alt="Soldeu Golf video">' +
            '<div class="vscrim"></div><div class="play"><i class="fa-solid fa-play"></i></div>' +
          '</div>' +
        '</div></section>' +
        '<section class="pad" id="about"><div class="wrap"><div class="about-grid">' +
          '<div class="reveal"><div style="position:relative"><div class="photo ar45"><img src="' + IMG.joan + '" alt="Joan Monzó"></div>' +
            '<div class="about-badge"><div class="n">+350</div><div class="l">' + t.about.name + '</div></div></div></div>' +
          '<div>' +
            '<div class="kicker reveal">' + t.about.kicker + '</div>' +
            '<h2 class="title-lg serif reveal" style="margin-top:20px">' + t.about.name + '</h2>' +
            '<div class="role reveal" style="color:var(--muted);margin-top:8px">' + t.about.role + '</div>' +
            aparas +
            '<div class="credits reveal"><div class="t">' + t.about.creditsTitle + '</div><div style="display:flex;flex-wrap:wrap;gap:16px 48px">' + credits + '</div></div>' +
          '</div>' +
        '</div></div></section>' +
        '<footer><div class="wrap">' +
          '<div class="foot-cta reveal"><h2 data-scrolltop>' + t.footer.cta + ' <i class="fa-solid fa-arrow-up-right-from-square"></i></h2></div>' +
          '<div class="foot-mid">' +
            '<div><div class="logo" style="color:var(--bg)"><span class="zero" style="border-color:#9cb39f">0</span>Forat Zero</div><div class="foot-loc"><i class="fa-solid fa-location-dot"></i>' + t.footer.location + '</div></div>' +
            '<div style="display:flex;flex-direction:column;gap:16px;align-items:flex-start">' +
              '<button class="wa-foot" data-wa><i class="fa-brands fa-whatsapp"></i>' + t.footer.book + '</button>' +
              '<a href="tel:+' + WHATSAPP + '" style="color:#9cb39f;font-size:14px">+34 664 368 737</a>' +
            '</div>' +
          '</div>' +
          '<div class="foot-bottom"><span>© ' + (new Date().getFullYear()) + ' Forat Zero · Soldeu Golf. ' + t.footer.rights + '</span><span>Grandvalira · Ugolf Aravell</span></div>' +
        '</div></footer>' +
        '<div class="mobile-only-book"><button class="btn" data-wa>' + t.nav.book + '</button></div>';

      bind();
    }

    const langBtn = document.getElementById('langBtn');
    const langMenu = document.getElementById('langMenu');
    langBtn.onclick = function (e) { e.stopPropagation(); langMenu.classList.toggle('open'); };
    langMenu.onclick = function (e) {
      const b = e.target.closest('[data-lang]');
      if (!b) return;
      lang = b.getAttribute('data-lang');
      localStorage.setItem('fz_lang', lang);
      langMenu.classList.remove('open');
      render();
      window.scrollTo({ top: 0 });
    };
    const docClick = function () { langMenu.classList.remove('open'); };
    document.addEventListener('click', docClick);

    const onScroll = function () {
      const h = document.getElementById('header'), wf = document.getElementById('waFloat');
      if (!h || !wf) return;
      if (window.scrollY > 40) h.classList.add('scrolled'); else h.classList.remove('scrolled');
      if (window.scrollY > window.innerHeight * 0.7) wf.classList.add('show'); else wf.classList.remove('show');
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    render();

    return () => {
      document.removeEventListener('click', docClick);
      window.removeEventListener('scroll', onScroll);
      if (obs) obs.disconnect();
    };
  }, [data]);

  return (
    <div data-testid="soldeu-landing" style={{ background: '#F4F6F0', minHeight: '100vh' }}>
      <header id="header">
        <div className="wrap hrow">
          <a href="#top" className="logo"><span className="zero">0</span>Forat&nbsp;Zero</a>
          <nav className="main" id="navmain"></nav>
          <div className="hactions">
            <div className="lang">
              <button className="lang-btn" id="langBtn" data-testid="soldeu-lang-btn"><i className="fa-solid fa-globe"></i><span className="code" id="langCode"></span></button>
              <div className="lang-menu" id="langMenu"></div>
            </div>
            <button className="btn header-book" data-wa id="headerBook" data-testid="soldeu-header-book"></button>
          </div>
        </div>
      </header>
      <main id="app"></main>
      <button className="wa-float" id="waFloat" data-wa aria-label="WhatsApp" data-testid="soldeu-wa-float">
        <i className="fa-brands fa-whatsapp"></i><span className="txt" id="waFloatTxt"></span>
      </button>
      <CookieBanner />
    </div>
  );
}
